import { Component, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { CustomerFormComponent } from "./customer-form.component";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { ColumnBase } from "@progress/kendo-angular-grid";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
@Component({
  selector: "ngx-customer-categories-list",
  template: `<div class="page" style="height:100%; padding:1rem; background: var(--bg-primary);">
    <kgrid
      #grid
      [apiName]="apiName"
      [noAutoFitColumns]="true"
      [areaName]="areaName"
      [label]="label"
      [name]="apiName"
      reportName="Customer"
      pathPreFix="SALE"
      defaultSortKey="Number"
      defaultSortKeyKind="asc"
      [unSortableFilterable]="unSortableFilterable"
      [isMulti]="true"
      [inputEditorform]="inputEditorform"
      [isAdd]="isAdd"
      [isEdit]="isEdit"
      [isDelete]="isDelete"
      [customExportExcelUrl]="'Customer/ExportExcel'"
      [getParamsForExportExcelWithPostMethod]="getParamsForExportExcelWithPostMethod.bind(this)">
    </kgrid>
  </div>`,
})
export class CustomerListComponent extends BaseListComponent {
  @ViewChild("grid") grid: KGridComponent;
  unSortableFilterable: string[] = [];
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  constructor() {
    super();
    this.inputEditorform = CustomerFormComponent;
  }
  ngOnInit() {
    this.apiName = "Customer/GetCustomers";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Parties.Customer.Customer");
    this.unSortableFilterable.push("NumberTypeTitle");
    this.unSortableFilterable.push("ZoneTitle");
    this.unSortableFilterable.push("Address");
    this.unSortableFilterable.push("ShippingCost");
    this.unSortableFilterable.push("CourierShippingCost");
    this.unSortableFilterable.push("BuyCount");
    this.unSortableFilterable.push("MinutesToDelivery");
    this.unSortableFilterable.push("LastBuy");
    this.unSortableFilterable.push("MaxBuy");
    this.unSortableFilterable.push("MintBuy");
    this.unSortableFilterable.push("MintBuy");
    this.unSortableFilterable.push("CreatedUser");
    this.unSortableFilterable.push("EditedUser");
  }
  async FillData() {
    const info = this.accountService.authService.currentInformation();
    if (info.RestaurantCallCenter) {
      if (!this.accountService.authService.currentBranch.AccessToAllBranches) {
        this.isAdd = false;
        this.isEdit = false;
        this.isDelete = false;
      }
    }
  }

  getParamsForExportExcelWithPostMethod(): Promise<any> {
    return new Promise((resolve, reject) => {
      resolve(this.getGridInfo(this.grid.grid.columns.toArray()));
    });
  }

  getGridInfo(columns: ColumnBase[]): GridColumnInfoDetail[] {
    return columns
      .filter((x) => !x.hidden)
      .map((x) => {
        const info = new GridColumnInfoDetail();
        info.name = x["field"];
        info.hidden = x.hidden;
        info.orderindex = x.orderIndex;
        info.title = x.title;
        return info;
      });
  }
}
